import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    modalContent: {
        minHeight: "300px",
        maxHeight: "500px",
        overflow: "auto",
    },
    emptyState: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    filesContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    cardContent: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    metadataRow: {
        display: "flex",
        gap: theme.spacing(4),
        flexWrap: "wrap",
    },
    propertyItem: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        minWidth: "200px",
        flex: 1,
    },
    propertyValue: {
        wordBreak: "break-word",
    },
    sha256Typography: {
        cursor: "help",
    },
    compatibilityContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(2),
        alignItems: "flex-end",
    },
    compatibilityInput: {
        flex: 1,
        minWidth: "240px",
        marginTop: theme.spacing(1),
    },
    saveButton: {
        alignSelf: "flex-end",
    },
}));
